/* MAISON ALMEA — HEADER MOBILE (10/09/2026), version 15/09/2026 « une seule passe ».
   AVANT : ce script relisait et repeignait le header a CHAQUE image du defilement
   (requestAnimationFrame + MutationObserver + getComputedStyle sur chaque trait
   d'icone) et se battait avec la couche de la fiche produit qui ecrit, elle
   aussi, des styles en ligne. Resultat : icones qui clignotent et saccades.
   MAINTENANT : une seule intervention au chargement (l'icone du panier devient le
   pochon). Tout le reste — compte masque, barre a 58 px, encre sur pages claires,
   glissement -101 % — est ecrit en CSS dans almea-header-mobile-20260910.css et
   ne bouge plus. Aucun ecouteur de defilement, aucun observateur. */
(function () {
  var POCHON = '<path d="M4.5 9h15l-1.2 11H5.7L4.5 9Z"/>'
             + '<path d="M4.5 9 7 4.2h10L19.5 9"/>'
             + '<path d="M9.4 12.4h5.2"/>';
  function pochon() {
    var h = document.getElementById('mzHeader');
    if (!h) { return false; }
    var svg = h.querySelector('.mz-action--cart svg');
    if (!svg) { return false; }
    if (svg.getAttribute('data-alm-panier') === 'pochon') { return true; }
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.innerHTML = POCHON;
    svg.setAttribute('data-alm-panier', 'pochon');
    return true;
  }
  if (!pochon()) {
    document.addEventListener('DOMContentLoaded', pochon);
  }
})();
